import { render, staticRenderFns } from "./BotanalyticsInfo.vue?vue&type=template&id=441bb48c&"
import script from "./BotanalyticsInfo.vue?vue&type=script&lang=js&"
export * from "./BotanalyticsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports